import Image from "next/image";
import { getTranslationFor } from "@/text/translations";
import ApplicationButton from "@/components/ApplicationButton/ApplicationButton";
import styles from "./GuideHero.module.css";

export default function GuideHero() {
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>
          {getTranslationFor("integrationGuide.hero.title")}
        </h1>
        <p className={styles.paragraph}>
          {getTranslationFor("integrationGuide.hero.paragraph1")}
        </p>
        <p className={styles.paragraph}>
          {getTranslationFor("integrationGuide.hero.paragraph2")}
        </p>
        <ApplicationButton className={styles.button}>
          {getTranslationFor("integrationGuide.hero.button")}
        </ApplicationButton>
      </div>
      <div className={styles.imageWrapper}>
        <Image
          src="/images/house-landscape.png"
          alt="House illustration"
          width={286}
          height={200}
          className={styles.image}
          priority
          unoptimized={true}
        />
      </div>
    </section>
  );
}
